import React, { useState } from "react";
import logo from "../logo-vpvv.png";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useLocation } from "react-router-dom";

const IcDepartureDetails = () => {
  const location = useLocation();
  const [numGuests, setNumGuests] = useState(location.state?.numGuests || 1);
  const [step, setSteps] = useState(5);

  // State to track selected travel method for each guest
  const [travelMethods, setTravelMethods] = useState(Array(numGuests).fill(""));

  const handleTravelMethodChange = (index, method) => {
    const updatedMethods = [...travelMethods];
    updatedMethods[index] = method;
    setTravelMethods(updatedMethods);
  };

  return (
    <>
      <div className="ic-container">
        <img src={logo} alt="logo" style={{ width: "150px" }} />
        <h2 style={{ color: "white" }}>
          VPVV TECHNO CONSTRUCTION PRIVATE LIMITED
        </h2>

        <div className="ic-form">
          <h2 className="form-title">Travel Departure Details</h2>
          <div className="progress_container">
            <div className={`${step >= 1 ? "circle active" : "circle"}`}>1</div>
            <div className={`${step >= 2 ? "circle active" : "circle"}`}>2</div>
            <div className={`${step >= 3 ? "circle active" : "circle"}`}>3</div>
            <div className={`${step >= 4 ? "circle active" : "circle"}`}>4</div>
            <div className={`${step >= 5 ? "circle active" : "circle"}`}>5</div>
          </div>

          {Array.from({ length: numGuests }).map((_, index) => (
            <div key={index}>
              <h5 className="guestSeries">Guest {index + 1}</h5>

              <Form>
                <Form.Label>Travel Method</Form.Label>
                <Form.Select
                  aria-label="Select Travel Method"
                  required
                  style={{ marginBottom: "1rem" }}
                  onChange={(e) =>
                    handleTravelMethodChange(index, e.target.value)
                  }
                >
                  <option value="">Select...</option>
                  <option value="Flight">By Flight</option>
                  <option value="Train">By Train</option>
                  <option value="Road">By Road</option>
                </Form.Select>

                {/* Show travel details only when a method is selected */}
                {travelMethods[index] && (
                  <>
                    {/* Common Date & Time Fields */}
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId={`formGridDate-${index}`}>
                        <Form.Label>Date</Form.Label>
                        <Form.Control type="date" required />
                      </Form.Group>

                      <Form.Group as={Col} controlId={`formGridTime-${index}`}>
                        <Form.Label>Time</Form.Label>
                        <Form.Control type="time" required />
                      </Form.Group>
                    </Row>
                  </>
                )}

                {/* Flight Form */}
                {travelMethods[index] === "Flight" && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>By Flight Details</Form.Label>
                      <Row>
                        <Col>
                          <Form.Control
                            type="text"
                            placeholder="PNR"
                            required
                          />
                        </Col>
                        <Col>
                          <Form.Control
                            placeholder="From"
                            value="DELHI"
                            disabled
                          />
                        </Col>
                        <Col>
                          <Form.Control placeholder="To" required />
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group controlId="formFileMultiple" className="mb-3">
                      <Form.Label>Please Upload Flight Ticket</Form.Label>
                      <Form.Control type="file" multiple />
                    </Form.Group>
                  </>
                )}

                {/* Train Form */}
                {travelMethods[index] === "Train" && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>By Train Details</Form.Label>
                      <Row>
                        <Col>
                          <Form.Control
                            type="text"
                            placeholder="PNR"
                            required
                          />
                        </Col>
                        <Col>
                          <Form.Select
                            aria-label="Default select example"
                            required
                          >
                            <option>Select...</option>
                            <option value="NewDelhi">New Delhi Railway</option>
                            <option value="OldDelhi">Old Delhi Railway</option>
                            <option value="Nizamuddin">
                              Nizamuddin Railway
                            </option>
                          </Form.Select>
                        </Col>
                        <Col>
                          <Form.Control placeholder="To" required />
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group controlId="formFileMultiple" className="mb-3">
                      <Form.Label>Please Upload Train Ticket</Form.Label>
                      <Form.Control type="file" multiple />
                    </Form.Group>
                  </>
                )}

                {/* By Road Form */}
                {travelMethods[index] === "Road" && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>By Road Details</Form.Label>
                      <Row>
                        <Col>
                          <Form.Control
                            placeholder="From"
                            value="DELHI"
                            disabled
                          />
                        </Col>
                        <Col>
                          <Form.Control placeholder="To" required />
                        </Col>
                      </Row>
                    </Form.Group>
                  </>
                )}
              </Form>
            </div>
          ))}

          <Button
            variant="primary"
            style={{ width: "670px", marginTop: "1rem" }}
          >
            Submit Form
          </Button>
        </div>
      </div>
    </>
  );
};

export default IcDepartureDetails;
